import {FUIBreakpoint} from "./breakpoint.model";

/**
 * These correspond to the breakpoints specified in
 * SCSS. These are used in instances where we need to
 * change a value or functionality between view types.
 * Avoid using these where possible to rely on SCSS.
 *
 * small: 0 - 680px,
 * medium: 680px - 770px,
 * large:  770px - 1280px,
 * xlarge: 1280px - 1920px
 */

export class FUIBreakpoints {
    public static smallUp: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 0,
        title: "small up"
    });
    public static smallOnly: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 0,
        title: "small only",
        maxWidth: 679
    });
    public static smallDown: FUIBreakpoint = new FUIBreakpoint({
        title: "small down",
        maxWidth: 679
    });
    public static mediumUp: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 680,
        title: "medium up"
    });
    public static mediumOnly: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 680,
        title: "medium only",
        maxWidth: 769
    });
    public static mediumDown: FUIBreakpoint = new FUIBreakpoint({
        title: "medium down",
        maxWidth: 769
    });
    public static largeUp: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 770,
        title: "large up"
    });
    public static largeOnly: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 770,
        title: "large only",
        maxWidth: 1023
    });
    public static largeDown: FUIBreakpoint = new FUIBreakpoint({
        title: "large down",
        maxWidth: 1023
    });
    public static xlargeUp: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 1024,
        title: "xlarge up"
    });
    public static xlargeOnly: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 1024,
        title: "xlarge only",
        maxWidth: 1279
    });
    public static xlargeDown: FUIBreakpoint = new FUIBreakpoint({
        title: "xlarge down",
        maxWidth: 1279
    });
    public static xxlargeUp: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 1280,
        title: "xlarge up"
    });
    public static xxlargeOnly: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 1280,
        title: "xlarge only",
        maxWidth: 1919
    });
    public static xxlargeDown: FUIBreakpoint = new FUIBreakpoint({
        title: "xlarge down",
        maxWidth: 1919
    });
    public static xxxlargeUp: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 1920,
        title: "xlarge up"
    });
    public static xxxlargeOnly: FUIBreakpoint = new FUIBreakpoint({
        minWidth: 1920,
        title: "xlarge only"
    });
    public static xxxlargeDown: FUIBreakpoint = new FUIBreakpoint({
        title: "xlarge up"
    });
    public static shortDown: FUIBreakpoint = new FUIBreakpoint({
        title: "short down",
        maxHeight: 599
    });
    public static normalUp: FUIBreakpoint = new FUIBreakpoint({
        title: "normal up",
        minHeight: 600
    });
}
